/* istanbul ignore file */
import React from 'react';
import BreadcrumbItem from './BreadcrumbItem';
import type { EntityBreadcrumbItemProps } from '../BreadcrumbsTypes';

const CreateBreadcrumbItem = ({ entity, ...props }: EntityBreadcrumbItemProps) => {
  return <BreadcrumbItem {...props}>{`Create ${entity}`}</BreadcrumbItem>;
};

export default CreateBreadcrumbItem;
